<template>
  <div style="background: #F8F8F8">
    <div class="address-link">
      <div>
        <div class="lineWord" style="margin-bottom: 14px ;">快递企业：{{logisticsProvider}}</div>
        <div class="lineWord">快递单号：{{nu}}</div>
      </div>
    </div>
    <div class="container" v-if="logistics.length > 0">
      <van-steps direction="vertical" :active="0">
        <van-step v-for="(item, index) in logistics">
          <h3>{{item.context}}</h3>
          <p>{{item.ftime}}</p>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>
<script>
export default {
  name: 'protocol',
  components: {

  },
  data () {
    return {
      logistics: [],
      logisticsProvider: '',
      nu: ''
    }
  },
  beforeCreate () {

  },
  created () {
    this.id = this.$route.query.id;
    this.getLogisticsTracking();
  },
  mounted () {

  },
  methods: {
    // 获取物流
    getLogisticsTracking () {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          id: this.id
        }
      }
      this.$api.getLogisticsTracking(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            this.logistics = res.data.result.data;
            this.logisticsProvider = res.data.result.logisticsProvider;
            this.nu = res.data.result.nu;
            if (!this.logistics) {
              this.logistics = []
            }
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.lineWord{
  color: #3E3E3E;
  font-size: 28px;
}
/*公共样式*/
html {
  -webkit-text-size-adjust: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  touch-action: none;
}

body {
  height: 100%;
  user-select: none;

}

body * {
  user-select: inherit;
}

body .user-select {
  user-select: initial;
}

a,
h1,
h2,
h3,
img,
body,
html,
ul,
li,
p {
  margin: 0;
  padding: 0;
}

img {
  border: 0;
  vertical-align: middle;
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}

.clearfix {
  zoom: 1;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.container{
  font-size: 0.28rem;
  margin:0px  0 0;
  color:#333;
  overflow: auto;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  border-radius: 12px 12px 0px 0px;
}
.title{
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  padding:0.5rem 0;
}
.privacy-title{

  font-size: 0.4rem;
  font-weight: bold;
  padding:0.5rem 0;
}
.title-subhead{
  font-size: 34px;
  font-weight: bold;
  padding:0.3rem 0;
}
.list-text{
  text-indent: 0.5rem;
  line-height: 1.6em;
  padding-bottom: 0.1rem;
  font-size: 32px;
}
.subhead{
  font-weight: bold;
  text-indent: 0.5rem;
  padding-bottom: 0.1rem;
}
.privacy-subhead{
  font-weight: bold;
  padding-bottom: 0.1rem;
}
.company-text{
  padding-top: 0.4rem;
}
.time{
  padding-top: 0.1rem;
  padding-bottom: 0.2rem;
}
.padding-bottom{
  padding-bottom: 0.1rem;
}


</style>
